import { BaseDto } from './base-dto';

export class DashCitasPendientesrealizadasSemana extends BaseDto {
    public pendientes !: number;
    public tot_citas !: number;
    public realizadas !: number;
    public porcen_completado !: number;
    public porcen_pendiente !: number;
 } 
